import { RepairService } from '../types/BookingTypes';
import { API_BASE_URL } from '../constants';

export interface ServiceApiResponse {
  entity: {
    id: number;
    makeId: number;
    modelId: number;
    modelName: string | null;
    serviceName: string;
    serviceImage: string;
    modelImage: string;
    actualPrice: number;
    markedPrice: number;
    serviceDuration: number;
    serviceCost: number;
    serviceImagePath: string | null;
    modelImagePath: string | null;
    warrantyName: string;
    warrantyTypeDescription: string;
    warrantyCoveredItems: string;
    warrantyNotCoveredItems: string;
    warrantyPeriod: number;
    finalPrice: number;
  }[];
  isSuccess: boolean;
  errors: string | null;
  exception: string | null;
  message: string | null;
}

const CDN_BASE_URL = 'https://admin.mintomein.in/public/uploads/';

export const getServicesByModelId = async (modelId: number): Promise<RepairService[]> => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/model/${modelId}/servicetypes`,
      {
        method: 'GET',
        headers: {
          'accept': 'application/json, text/plain, */*',
        },
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data: ServiceApiResponse = await response.json();

    if (!data.isSuccess) {
      throw new Error(data.errors || 'Failed to fetch services');
    }

    // Transform API response to match our RepairService interface
    return data.entity.map(service => ({
      id: service.id,
      makeId: service.makeId,
      modelId: service.modelId,
      modelName: service.modelName || '',
      makeName: 'UNKNOWN',
      serviceName: service.serviceName,
      serviceImage: service.serviceImage.startsWith('http') ? service.serviceImage : `${CDN_BASE_URL}${service.serviceImage}`,
      modelImage: service.modelImage ? (service.modelImage.startsWith('http') ? service.modelImage : `${CDN_BASE_URL}${service.modelImage}`) : null,
      actualPrice: service.actualPrice,
      markedPrice: service.markedPrice,
      serviceDuration: service.serviceDuration,
      serviceCost: service.serviceCost,
      serviceImagePath: service.serviceImagePath,
      modelImagePath: service.modelImagePath,
      warrantyTypeId: 1,
      warrantyName: service.warrantyName,
      warrantyTypeDescription: service.warrantyTypeDescription,
      warrantyCoveredItems: service.warrantyCoveredItems,
      warrantyNotCoveredItems: service.warrantyNotCoveredItems,
      warrantyPeriod: service.warrantyPeriod,
      serviceImageBytes: null,
      finalPrice: service.finalPrice ?? 0,
    }));

  } catch (error) {
    console.error('Error fetching services:', error);
    throw error;
  }
}; 